module.exports = __webpack_public_path__ + "static/media/HanWangMingMedium.d73437b8.svg";